import { AttachmentDetails } from "./user-chat-detail";

export class FileUploadDetails {
    externalUrl: string;
    azureFileName: string;
    azureContainerName: string;
    displayName: string;
    fileType: string;

    constructor() {
        this.externalUrl = "";
        this.azureFileName = "";
        this.azureContainerName = "";
        this.displayName = "";
        this.fileType = "";
    }
}

export class FileFetchData {
    data: string = "";
    metadata: any;
}

export class UrlUploadRequest {
    ExternalUrl: string;
    AzureContainerName: string;
    AzureFileName: string;

    constructor() {
        this.ExternalUrl = "";
        this.AzureContainerName = "";
        this.AzureFileName = "";
    }
}

export class UploadResponse {
    ExternalUrl: string;
    AzureFileName: string;
    AzureContainerName: string;
    DisplayName: string;
    FileType: string;
    data: string;
    metadata: any;
    MD5: string;

    constructor() {
        this.ExternalUrl = "";
        this.AzureFileName = "";
        this.AzureContainerName = "";
        this.DisplayName = "";
        this.FileType = "";
        this.data = "";
        this.MD5 = "";
    }
}

export class GetDocumentDto {
    id:number;
    documentName: string;
    containerName: string;
    link?: string;
    constructor() {
        this.id = 0;
        this.documentName = "";
        this.containerName = "";
    }
}

export class ExtractedMSGDOCX {
    id = 0;
    externalUrl = "";
    azureFileName = "";
    azureContainerName = "";
    fileType = "";
    displayName = "";
}

export class RequestMSGDOCX {
    ExternalUrl = "";
    AzureFileName = "";
    AzureContainerName = "";
}


export class AttachmentProcessingDetails {
    Id: number;
    AzureFileName: string;
    DisplayName: string;
    FileType: string;
    AzureContainerName: string;
    ExternalUrl: string;
    MD5: string;
    GlobalAccess: boolean;
    UpdatesID: number;
    Metadata: string;
    constructor() {
        this.Id = 0;
        this.AzureContainerName = "";
        this.AzureFileName = "";
        this.DisplayName = "";
        this.FileType = "";
        this.ExternalUrl = "";
        this.MD5 = "";
        this.GlobalAccess = false;
        this.UpdatesID = 0;
        this.Metadata = "";
    }
}

export class AttachmentProcessingResponse {
    Id: number = 0;
    MD5: string = "";
    ProcessingStatus: string = "";
}

export class QuestionResponse{
    Questions: string = "";
    ProcResponse:AttachmentProcessingResponse[] = [];
}

export class DeleteDocumentDto{
    uuid = "";
    AttachmentId = 0;
    ContainerName = "";
    DisplayName = "";
}

export class ChatRequest{
    ChatUUID = "";
    Question = "";
}

export class ChatResponse{
    role = "";
    content = "";
    source:ChatSource[] = [];
}

export class ChatSource{
    title = "";
    pageNo = 0;
}

export class AddChat{
    uuid = "";
    chatDetails = "";
}

export class RenameChatDto{
    uuid:string = "";
    userId:string = "";
    chatName:string = "";
}

export class AttachmentMD5Request{
    uuid:string = "";
    attachment:string = "";
}
export class UserDropdownData{
    id:number = 0;
    displayName:string = "";
    userId:string = "";
}

export class SharedChatAddDto{
    sharedBy:string = "";
    sharedWith:string[] = [];
    uuid:string = "";
}

export class CombinedChatDetails{
    id:number = 0;
    sharedBy:string = "";
    sharedWith:string = "";
    uUID:string = "";
    isShared:boolean = false;
    createdDateTime:Date = new Date();
    updatedDateTime:Date = new Date();
    chatName:string = "";
    senderName:string = "";
    isActive:boolean = false;
}

export class SharedChatDeleteDto{
    sharedWith:string = "";
    uuid:string = "";
}